export enum TaskPriority {
  'LOW' = 'LOW',
  'MEDIUM' = 'MEDIUM',
  'HIGH' = 'HIGH',
}

export enum TaskPriorityClass {
  'LOW' = 'light',
  'MEDIUM' = 'warning',
  'HIGH' = 'danger',
}

// Using new design library theme colors: 'primary', 'secondary', 'tertiary', 'danger', 'warning', 'success', or 'neutral'

export enum TaskPriorityColor {
  'LOW' = 'neutral',
  'MEDIUM' = 'warning',
  'HIGH' = 'danger',
}
